export * as color from './color';
export * as fontWeight from './fontWeight';
export * as lineHeight from './lineHeight'
